<ng-container *ngrxLet="routeData$ as routeData">
  <header role="banner">
    <cigna-header
      [logoLink]="logoLink$ | async"
      [isLogoLinkInternal]="(isResourcePage$ | async) === false"
      [isAuthenticated]="false"
      [isNavigationDisabled]="routeData.disableNavigation"
    ></cigna-header>
  </header>

  <main role="main">
    <router-outlet></router-outlet>
  </main>

  <cigna-footer-global
    *ngIf="!routeData.disableNavigation"
  ></cigna-footer-global>
</ng-container>
